import { render, staticRenderFns } from "./Ckeditor4.vue?vue&type=template&id=1f39943a&"
import script from "./Ckeditor4.vue?vue&type=script&lang=js&"
export * from "./Ckeditor4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports